import { atom } from "recoil";

export const driverDetailAtom = atom({
    key: "driverDetailAtom",
    default: {}
})
